function AdvertisingCatalog() {
    const advertisingContainer = document.querySelector(".advertising-catalog");
    if (advertisingContainer) {
        const cardsContainer = document.querySelector(".results .results-box");
        const cards = cardsContainer.querySelectorAll(".results .results-box .card-item");
        const ads = document.querySelectorAll(".container-image-advertising .vocabulary-ad-banners .image-advertising");
        const minPositionOffset = +advertisingContainer.querySelector('.container-image-advertising').getAttribute('data-min-position-ad-banner');
        const row_size = +document.querySelector(".results .item-container").getAttribute('data-row-size');
        let lastAdSize = 0;
        let position = 0;
        let totalInsertedAdSize = 0;
        function setSingleImage(ads) {
            ads.forEach((advertising) => {
                const attrOrientation = advertising.getAttribute('data-orientation');
                const adSize = +advertising.getAttribute('data-grid-size');
                position += minPositionOffset;
                const leftOffset = (position + totalInsertedAdSize) % row_size;
                const rightOffset = row_size - leftOffset;
                const newCard = document.createElement('div');
                newCard.classList.add('card-item', 'generic', 'border-full');
                if (adSize === 2) {
                    newCard.classList.add('grid2');
                }
                else if (adSize === 3) {
                    newCard.classList.add('grid3');
                }
                else if (adSize === 4) {
                    newCard.classList.add('grid4');
                }
                switch (attrOrientation) {
                    case 'left':
                        if (leftOffset > 0) {
                            (position += rightOffset);
                        }
                        break;
                    case 'center':
                        if (adSize === 2) {
                            if (leftOffset < 1) {
                                position += 1;
                            }
                            else if (leftOffset > 1) {
                                position += rightOffset + 1;
                            }
                        }
                        else {
                            position += rightOffset;
                        }
                        break;
                    case 'right':
                        if (rightOffset <= adSize) {
                            position += rightOffset + (row_size - adSize);
                        }
                        else {
                            position += row_size - adSize;
                        }
                        break;
                }
                setAds(newCard, advertising, position, adSize);
            });
        }
        const setAds = (newCard, advertising, position, adSize) => {
            if (position < cards.length) {
                newCard.appendChild(advertising);
                cardsContainer.insertBefore(newCard, cards[position]);
                lastAdSize = adSize;
                totalInsertedAdSize += adSize;
            }
        };
        setSingleImage(ads);
    }
}
